import React from 'react';

import { SageRegisterForm, SageRegisterFormProps } from '../../register/components/sage-register-form';

export const SageInviteForm = (props: SageRegisterFormProps) => {
  return <SageRegisterForm {...props} />;
};
